export default __webpack_public_path__ + "static/bash-c23f223b9091ea7477ca13337f257353.png";